import { i18n } from "@/plugins/i18n";

function getOptions(content, title, options) {
  return {
    title: title,
    cancelTitle: i18n.t("cancel"),
    okTitle: "ok",
    cancelVariant: "outline-primary",
    centered: true,
    bodyClass: content ? "pt-0 pb-4" : "d-none",
    noCloseOnBackdrop: true,
    noCloseOnEsc: true,
    ...options,
  };
}

export default {
  methods: {
    /**
     *
     * @param title
     * @param content
     * @param options //see: https://bootstrap-vue.org/docs/components/modal#modal-message-boxes
     * @return {Promise<BvMsgBoxData>}
     */
    mxConfirmBox(title, content, options = {}) {
      const message = content || "none";

      return this.$bvModal.msgBoxConfirm(
        message,
        getOptions(content, title, options)
      );
    },
    /**
     *
     * @param title
     * @param content
     * @param options //see: https://bootstrap-vue.org/docs/components/modal#modal-message-boxes
     */
    mxMessageBox(title, content, options = {}) {
      const message = content || "none";
      this.$bvModal.msgBoxOk(message, getOptions(content, title, options));
    },
  },
};
